import { MChatPerguntaEnum, MChatRiscoEnum } from 'graphql/types.generated'
import HistoricoDetailTable from 'view/atendimentos/detail/historico/components/table/HistoricoDetailTable'
import {
  MCHAT_RESULTADOS,
  MCHAT_RF_RESULTADO_BY_STATUS,
  MchatRfAplicacaoQueryModel,
} from 'view/atendimentos/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatRfPergunta01 } from './historico-mchatrf-pergunta01/HistoricoMchatRfPergunta01'
import { HistoricoMChatRfPergunta02 } from './historico-mchatrf-pergunta02/HistoricoMchatRfPergunta02'
import { HistoricoMChatRfPergunta03 } from './historico-mchatrf-pergunta03/HistoricoMchatRfPergunta03'
import { HistoricoMChatRfPergunta04 } from './historico-mchatrf-pergunta04/HistoricoMchatRfPergunta04'
import { HistoricoMChatRfPergunta05 } from './historico-mchatrf-pergunta05/HistoricoMchatRfPergunta05'
import { HistoricoMChatRfPergunta06 } from './historico-mchatrf-pergunta06/HistoricoMchatRfPergunta06'
import { HistoricoMChatRfPergunta07 } from './historico-mchatrf-pergunta07/HistoricoMchatRfPergunta07'
import { HistoricoMChatRfPergunta08 } from './historico-mchatrf-pergunta08/HistoricoMchatRfPergunta08'
import { HistoricoMChatRfPergunta09 } from './historico-mchatrf-pergunta09/HistoricoMchatRfPergunta09'
import { HistoricoMChatRfPergunta10 } from './historico-mchatrf-pergunta10/HistoricoMchatRfPergunta10'
import { HistoricoMChatRfPergunta11 } from './historico-mchatrf-pergunta11/HistoricoMchatRfPergunta11'
import { HistoricoMChatRfPergunta12 } from './historico-mchatrf-pergunta12/HistoricoMchatRfPergunta12'
import { HistoricoMChatRfPergunta13 } from './historico-mchatrf-pergunta13/HistoricoMchatRfPergunta13'
import { HistoricoMChatRfPergunta14 } from './historico-mchatrf-pergunta14/HistoricoMchatRfPergunta14'
import { HistoricoMChatRfPergunta15 } from './historico-mchatrf-pergunta15/HistoricoMchatRfPergunta15'
import { HistoricoMChatRfPergunta16 } from './historico-mchatrf-pergunta16/HistoricoMchatRfPergunta16'
import { HistoricoMChatRfPergunta17 } from './historico-mchatrf-pergunta17/HistoricoMchatRfPergunta17'
import { HistoricoMChatRfPergunta18 } from './historico-mchatrf-pergunta18/HistoricoMchatRfPergunta18'
import { HistoricoMChatRfPergunta19 } from './historico-mchatrf-pergunta19/HistoricoMchatRfPergunta19'
import { HistoricoMChatRfPergunta20 } from './historico-mchatrf-pergunta20/HistoricoMchatRfPergunta20'
import { HistoricoMChatResultado } from './HistoricoMChatResultado'
import { groupAplicacoesByPergunta } from './utils-HistoricoMchatRf'

interface HistoricoMChatRfTableBoxProps {
  risco: MChatRiscoEnum | null
  pontuacao: number
  aplicacao?: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export function HistoricoMChatRfTableBox(props: Readonly<HistoricoMChatRfTableBoxProps>) {
  const { risco, pontuacao, aplicacao } = props

  if (risco === null) return null

  const { title, encaminhamento, status } = MCHAT_RESULTADOS[risco]
  const { colorScale } = MCHAT_RF_RESULTADO_BY_STATUS[status]

  const aplicacoesByPergunta = groupAplicacoesByPergunta(aplicacao || [])

  return (
    <HistoricoDetailTable title='Entrevista de seguimento' hasNestedLines>
      <HistoricoMChatRfPergunta01 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_01]} />
      <HistoricoMChatRfPergunta02 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_02]} />
      <HistoricoMChatRfPergunta03 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_03]} />
      <HistoricoMChatRfPergunta04 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_04]} />
      <HistoricoMChatRfPergunta05 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_05]} />
      <HistoricoMChatRfPergunta06 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_06]} />
      <HistoricoMChatRfPergunta07 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_07]} />
      <HistoricoMChatRfPergunta08 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_08]} />
      <HistoricoMChatRfPergunta09 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_09]} />
      <HistoricoMChatRfPergunta10 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_10]} />
      <HistoricoMChatRfPergunta11 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_11]} />
      <HistoricoMChatRfPergunta12 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_12]} />
      <HistoricoMChatRfPergunta13 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_13]} />
      <HistoricoMChatRfPergunta14 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_14]} />
      <HistoricoMChatRfPergunta15 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_15]} />
      <HistoricoMChatRfPergunta16 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_16]} />
      <HistoricoMChatRfPergunta17 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_17]} />
      <HistoricoMChatRfPergunta18 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_18]} />
      <HistoricoMChatRfPergunta19 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_19]} />
      <HistoricoMChatRfPergunta20 aplicacoes={aplicacoesByPergunta[MChatPerguntaEnum.PERGUNTA_20]} />
      <HistoricoMChatResultado
        title={title}
        titleColor={colorScale.c40}
        encaminhamento={encaminhamento()}
        label={'Falhou em ' + 'pergunta'.pluralizeAndConcatValue(pontuacao)}
      />
    </HistoricoDetailTable>
  )
}
